import React, { useEffect } from 'react';

export interface IModalChildProps {
    onClose: () => void;
    onAccept: () => void;
}

interface IModalProps {
    children: JSX.Element;
}

export const ModalLarge = ({ children }: IModalProps) => {
    const body = document.body;
    const background = document.createElement('div');

    useEffect(() => {
        background.className = 'modal-backdrop fade in';
        if (!body.classList.contains('modal-open')) {
            body.classList.add('modal-open');
            body.appendChild(background);
            body.style.paddingRight = '17px';
        }

        return () => {
            if (body.classList.contains('modal-open')) {
                body.classList.remove('modal-open');
                body.style.paddingRight = '';
                if (body.contains(background)) {
                    body.removeChild(background);
                }
            }
        };
    }, []);

    return (
        <div
            className="bs-example-modal-lg modal fade in"
            style={{ display: 'block' }}
        >
            <div className="modal-dialog modal-lg">
                <div className="modal-content">{children}</div>
            </div>
        </div>
    );
};

export default ModalLarge;
